import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetJobPositionsList } from "../Responses/GetJobPositionsList";

export async function getJobPositionsList(data) {
	let response = await getAPIResponse("/v1/jobPosition-list", data);
	if (response === null) {
		return null;
	}
	let getJobPositionsList = GetJobPositionsList.createFromResponseData(response);
	return getJobPositionsList;
}